












import Vue from "vue";
import PathMenu from "@/components/menus/PathMenu.vue";
export default Vue.extend({
    name: "ToolbarTitle",
    components: {
        PathMenu
    },
    props: {
        showPortalName: Boolean,
        showPageLocation: Boolean,
        disablePortalClick: Boolean,
        pageLocation: String,
        portalId: Number,
        showDocumentTitle: Boolean,
        documentTitle: String
    }
});
